import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Loader } from "@itandi/itandi-bb-ui/Loader";
import Link from "next/link";
import { VendorSettingLayout } from "~/components/common/layouts/settings/VendorSettingLayout";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { ProfileSetting } from "~/components/specifics/vendors/settings/profiles/ProfileSetting";
import { VendorSessionProvider } from "~/context/VendorSession";
import { useSessions } from "~/hooks/vendors/useSessions";
import { PATH } from "~/pages/vendors/settings";
import SettingStyles from "../SettingStyle.module.scss";

export function Page() {
	const { data: session, isLoading } = useSessions().index();

	if (isLoading || !session?.vendorUser) {
		return <Loader />;
	}

	return (
		<VendorSessionProvider session={session}>
			<VendorLayoutV2>
				<VendorSettingLayout>
					<div className={SettingStyles.SpBreadcrumbsWrapper}>
						<Breadcrumbs
							items={[
								{ as: Link, href: PATH, label: "設定一覧" },
								{ label: "プロフィール詳細" }
							]}
						/>
					</div>
					<ProfileSetting vendorUser={session.vendorUser} />
				</VendorSettingLayout>
			</VendorLayoutV2>
		</VendorSessionProvider>
	);
}
